import dayjs, { type Dayjs } from 'dayjs';

export interface InventorySelectionContract {
    contract_number: string;
    status: string;
    original_due_date: string;
    extended_due_date: string | null;
    calculated_expiration_date: string;
}

/**
 * MySQL DATE columns reach the browser as UTC-midnight timestamps (`2026-09-07T00:00:00.000Z`),
 * which east of UTC parse to 03:00 local and fall after the range end. Delphi compares plain
 * DATE values, so keep only the calendar day, as local midnight.
 */
const calendarDay = (value: string): Dayjs => dayjs(value.slice(0, 10));

/** Delphi btnSelectUnu/btnSelectDoi: add matching rows without clearing manual choices. */
export function selectInventoryContracts(
    contracts: InventorySelectionContract[],
    selected: string[],
    fromDate: Dayjs,
    toDate: Dayjs,
    now: Dayjs = dayjs(),
): string[] {
    const selection = new Set(selected);
    const from = fromDate.startOf('day');
    const to = toDate.startOf('day');
    for (const contract of contracts) {
        const expiration = calendarDay(contract.calculated_expiration_date);
        const inRange = !expiration.isBefore(from) && !expiration.isAfter(to);
        let matches = contract.status === '!' && inRange;
        if (contract.status === '!!') {
            const postponementElapsed =
                contract.extended_due_date === null ||
                calendarDay(contract.extended_due_date).isBefore(now);
            matches =
                postponementElapsed &&
                (calendarDay(contract.original_due_date).isBefore(now) || inRange);
        }
        if (matches) selection.add(contract.contract_number);
    }
    return [...selection];
}
